import React, { useEffect, useState } from "react";
import { AspectRatio, Box, Button, Card, CardContent, CircularProgress, DialogContent, DialogTitle, FormControl, FormLabel, IconButton, Input, Modal, ModalClose, ModalDialog, Stack, Typography } from "@mui/joy";
import { toast } from 'react-toastify';
import { PageTitle } from "../../../components";
import { connect, useDispatch } from "react-redux";
import { EditRounded } from "@mui/icons-material";
import { FILE_BASE, STATUS } from "../../../constant";

import {
    clientDetailsReset,
    changePasswordRequest,
    changePasswordReset,
} from "../../../store/actions"

interface FormElements extends HTMLFormControlsCollection {
    oldPassword: HTMLInputElement;
    newPassrword: HTMLInputElement;
    confirmPassword: HTMLInputElement;
}
interface SignInFormElement extends HTMLFormElement {
    readonly elements: FormElements;
}

const ProfilePage = ({
    loginResult,

    changePasswordStatus,
    changePasswordResult,
    changePasswordErrorMessage,
}) => {

    const dispatch = useDispatch();

    const [name, setName] = useState('');
    const [profile, setProfile] = useState('');
    const [phone, setPhone] = useState('');
    const [role, setRole] = useState('');
    const [email, setEmail] = useState('')

    const [loading, setLoading] = useState(false)
    const [passModal, setPassModal] = useState(false)

    useEffect(() => {
        if (loginResult) {
            setName(loginResult.first_name +" "+ loginResult.middle_name +" "+ loginResult.last_name );
            setPhone(loginResult.mobile_num);
            setRole(loginResult.role);
            setEmail(loginResult.email);
        } 

        if (changePasswordStatus === STATUS.SUCCESS) {
            toast.success("Password changed successful")
            setLoading(false);
            setPassModal(false);
            dispatch(changePasswordReset())

        } else if (changePasswordStatus === STATUS.ERROR) {
            setLoading(false);
            dispatch(changePasswordReset())
            toast.error(changePasswordErrorMessage)
        }
    }, [loginResult, changePasswordStatus])

    const handleSubmit = (event) => {
        event.preventDefault();
        const formElements = event.currentTarget.elements;
        const data = {
            newPassword: formElements.newPassword.value,
            oldPassword: formElements.oldPassword.value,
            confirmPassword: formElements.confirmPassword.value,
        };
        console.log(data)
        if (data.newPassword && data.oldPassword && data.confirmPassword) {
            if (data.newPassword === data.confirmPassword) {
                setLoading(true)
                const datas = {
                    "old_password": data.oldPassword,
                    "new_password": data.newPassword
                }
                dispatch(changePasswordRequest(loginResult.token, datas));
            } else {
                toast.error('password does not match.')
            }
        } else {
            toast.error("Please insert all inputs")
        }

    }

    return (
        <Box>
            <PageTitle title={'Profile'} />

            <Card sx={{ maxWidth: 800, alignSelf: 'center', display: 'flex', m: 'auto' }}>
                <CardContent>
                    <Stack direction="row" spacing={2}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                // alignItems: 'center',
                                m: 'auto'
                            }}>
                            <Typography level="title-md">{name}</Typography>
                            <Typography level="body-sm">{phone} | {email}</Typography>
                            <Typography level="body-md">{{ 1: "Admin", 2: "Manager", 3: "Sale Officer", 4: "Quality Assurance Personnel" }[role]}</Typography>
                            <Button
                                variant="outlined"
                                size="sm"
                                sx={{ borderRadius: 30, mt: 1, color: 'background.appcolor' }}
                                onClick={() => setPassModal(true)}>
                                Change Password
                            </Button>
                        </Box>

                    </Stack>
                </CardContent>

            </Card>

            {/* password change modal */}
            <Modal open={passModal} >
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {  // ----------------> FOR MOBILE
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            // borderRadius: 0,
                            borderTopLeftRadius: 20,
                            borderTopRightRadius: 20,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                    })}>
                    <ModalClose variant="outlined" component="button" onClick={() => setPassModal(false)} />
                    <DialogTitle>Change Password</DialogTitle>
                    <DialogContent>Please enter old password and new password twice to verify.</DialogContent>
                    <form
                        onSubmit={handleSubmit}
                    >
                        <FormControl sx={{ pb: 1 }}>
                            <FormLabel>Old Password</FormLabel>
                            <Input
                                autoFocus
                                type="password"
                                name="oldPassword"
                                required
                            />
                        </FormControl>
                        <FormControl sx={{ mt: 1 }}>
                            <FormLabel>New Password</FormLabel>
                            <Input
                                autoFocus
                                type="password"
                                name="newPassword"
                                required
                            />
                        </FormControl>
                        <FormControl sx={{ pb: 1 }}>
                            <FormLabel>Confirm Password</FormLabel>
                            <Input
                                autoFocus
                                type="password"
                                name="confirmPassword"
                                required
                            />
                        </FormControl>

                        <Button
                            startDecorator={loading && <CircularProgress />}
                            type="submit"
                            // onClick={verifyOTP}
                            fullWidth>
                            {loading ? "LOADING..." : "CONFIRM"}
                        </Button>
                    </form>
                </ModalDialog>
            </Modal>
        </Box>
    )
}

const mapStateToProps = ({ auth}) => {
    const {
        otpResult: loginResult,
        changePasswordResult: changePasswordResult,
        changePasswordStatus: changePasswordStatus,
        changePasswordErrorMessage: changePasswordErrorMessage
    } = auth

    return {
        loginResult,

        changePasswordStatus,
        changePasswordResult,
        changePasswordErrorMessage,
    }
}

export default connect(mapStateToProps, {})(ProfilePage)